import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage, defineMessages} from 'react-intl';
import {getDirection, FORWARD} from './direction';
import {End, BreakWithoutTimer} from '../../constants/MatchPeriod';

const messages = defineMessages({
    forward: {
        id: 'grid.match-current-time.forward',
        defaultMessage: '{minute}\''
    },
    backward: {
        id: 'grid.match-current-time.backward',
        defaultMessage: 'ост. < {minute}\''
    }
});

class MatchTime extends React.Component {
    static propTypes = {
        sportId: React.PropTypes.number,
        period: React.PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.period !== nextProps.period;
    }

    render() {
        const {period, sportId} = this.props;

        if (period === undefined || sportId === undefined) {
            return false;
        }

        const periodId = period.get('id');

        if ((End[sportId] !== undefined && End[sportId].indexOf(periodId) !== -1) ||
            (BreakWithoutTimer[sportId] !== undefined && BreakWithoutTimer[sportId].indexOf(periodId) !== -1)) {
            return false;
        }

        const minute = period.get('minute');

        if (minute === 0) {
            return false;
        }

        const direction = getDirection(sportId);

        const message = direction === FORWARD ? messages.forward : messages.backward;

        const values = {minute};

        return (
            <FormattedMessage {...message} values={values}>
                {(message) => <span className="current-time">{message}</span>}
            </FormattedMessage>
        );
    }
}

function select(state, props) {
    const {section, id} = props;
    const match = state.application.getIn([section, 'matches', id]);

    let period;
    let sportId;
    if (match !== undefined) {
        period = match.get('period');
        sportId = match.get('sportId');
    }

    return {
        sportId,
        period
    };
}

export default connect(select, null, null, false)(MatchTime);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/matchStats/MatchTime.jsx